<style>
#berusahaPTSA_info,
#berusahaPTSA_paginate,
#berusahaPTSA_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>
    </div>
    <div v-if="!show">
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search" />
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nama_pemohon">Nama Pemohon</option>
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="lokasi">Provinsi</option>
                <option value="tanggal_pada_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_terbit_oss">Tgl. Penerbitan</option>
                <option value="nomor_oss">No. Izin Terbit</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl. Submit</option>
                <option value="tanggal_pada_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_terbit_oss">Tgl. Penerbitan</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="berusahaPTSA" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Pemohon</th>
              <th>Nomor Pemohon</th>
              <th>Jenis Kegiatan</th>
              <th>Provinsi</th>
              <th>Tgl. Permohonan</th>
              <th>Tgl. Penerbitan</th>
              <th>No. Izin Terbit</th>
              <th>PIC Pentek</th>
              <th>Unduh File</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in dataPermohonan" :key="index">
              <!-- No -->
              <td class="sticky-col second-col">
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ index +
                  pagination.firstInPage }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ index + pagination.firstInPage }}
                  </div>
                </span>
              </td>
              <!-- Nama Pemohon -->
              <td class="sticky-col second-col">
                <div v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <div style="width: 250px" class="text-wrap">
                    {{ row.nama_pemohon }}
                  </div>
                </div>
                <div v-else style="width: 250px" class="text-wrap">
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <div>{{ row.nama_pemohon }}</div>
                  </div>
                </div>
                <div v-if="
                  row.tipe_permohonan == 'Multi KBLI' &&
                  row.tipe_multi_kbli == 'Mengikuti'
                " class="text-secondary" style="font-size: 12px">
                  Pendukung
                </div>
                <div v-else-if="
                  row.tipe_permohonan == 'Multi KBLI' &&
                  row.tipe_multi_kbli == 'Proses'
                " class="text-primary" style="font-size: 12px">
                  Proses
                </div>
              </td>
              <!-- Nomor Permohonan -->
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ row.nomor_permohonan
                  }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.nomor_permohonan }}
                  </div>
                </span>
              </td>
              <!-- Jenis Kegiatan -->
              <td>
                <div class="text-wrap" v-if="row.status_verdok == 'Perbaikan Persyaratan'"
                  style="color: red; width: 300px">
                  {{ row.jenis_kegiatan }}
                </div>
                <div class="text-wrap" v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                    { width: '300px' },
                  ]">
                    {{ row.jenis_kegiatan }}
                  </div>
                </div>
              </td>
              <!-- Provinsi -->
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ row.lokasi }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.lokasi }}
                  </div>
                </span>
              </td>
              <!-- Tgl. Permohonan -->
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <td v-else :style="[
                row.prioritas ? { color: 'green' } : { color: 'black' },
              ]">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <!-- Tgl. Penerbitan -->
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_terbit_oss) }}
              </td>
              <td v-else :style="[
                row.prioritas ? { color: 'green' } : { color: 'black' },
              ]">
                {{ format_date(row.tanggal_terbit_oss) }}
              </td>
              <!-- No. Izin Terbit -->
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ row.nomor_oss }}
              </td>
              <td v-else :style="[
                row.prioritas ? { color: 'green' } : { color: 'black' },
              ]">
                {{ row.nomor_oss }}
              </td>
              <!-- PIC Pentek -->
              <td>
                {{ row.pic_name }}
              </td>
              <!-- Unduh File -->
              <td>
                <FileDownload :row="row"/>
              </td>
              <!-- Aksi -->
              <td>
                <div style="width: 200px">
                  <b-button-toolbar>
                    <b-button size="sm" variant="info" @click="
                      $router.push(
                        '/app/perizinan/detail-perizinan/' + row.id,
                      )
                      " class="text-white m-1"><i class="fa fa-eye" /> Detail</b-button>
                    <b-button size="sm" variant="warning" @click="showModalRekomendasi(row)" class="text-white m-1">
                      <i class="fa fa-pencil-square-o"></i> Buat Rekomendasi
                    </b-button>
                    <b-button size="sm" variant="primary" class="text-white m-1" @click="sendReminder(row)">
                      <i class="fa fa-envelope-o"></i> Kirim Pengingat
                    </b-button>
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai
            {{
              pagination.currentPage !== pagination.lastPage
                ? pagination.limit * pagination.currentPage
                : pagination.total
            }}
            dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="[
                'page-link',
                { active: i === `${pagination.currentPage}` },
              ]" href="#" @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="[
              'page-item',
              { disabled: pagination.currentPage === pagination.lastPage },
            ]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="[
              'page-item',
              { disabled: pagination.currentPage === pagination.lastPage },
            ]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <b-modal id="modal-rekomendasi" title="Buat Rekomendasi" size="md">
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label for="jenis_rekomendasi">
                Jenis Rekomendasi <span class="text-danger">*</span>
              </label>
              <v-select id="jenis_rekomendasi" v-model="formRekomendasi.jenis_rekomendasi"
                :options="['Habis Masa Berlaku', 'Pencabutan', 'Pembatalan']" name="Jenis Rekomendasi"
                v-validate="'required'" />
              <span class="text-danger" v-if="errors.has('Jenis Rekomendasi')">
                {{ errors.first('Jenis Rekomendasi') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label for="file_rekomendasi">
                <template v-if="
                  formRekomendasi.jenis_rekomendasi === 'Habis Masa Berlaku'
                ">
                  File Rekomendasi Habis Masa Berlaku
                </template>
                <template v-if="formRekomendasi.jenis_rekomendasi === 'Pencabutan'">
                  File Rekomendasi Pencabutan
                </template>
                <template v-if="formRekomendasi.jenis_rekomendasi === 'Pembatalan'">
                  File Rekomendasi Pembatalan
                </template>
                <span class="text-danger">*</span>
              </label>
              <InputFile id="file_rekomendasi" v-model="formRekomendasi.file_rekomendasi" name="File Rekomendasi"
                accept=".pdf" v-validate="'required'" />
              <span class="text-danger" v-if="errors.has('File Rekomendasi')">
                {{ errors.first('File Rekomendasi') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label for="nomor_surat_permohonan">
                Nomor Surat <span class="text-danger">*</span>
              </label>
              <b-form-input id="nomor_surat_permohonan" v-model="formRekomendasi.nomor_surat_permohonan"
                v-validate="'required'" name="Nomor Surat"></b-form-input>
              <span class="text-danger" v-if="errors.has('Nomor Surat')">
                {{ errors.first('Nomor Surat') }}
              </span>
            </div>
            <div v-if="formRekomendasi.jenis_rekomendasi === 'Pembatalan'" class="col-12 mt-3">
              <label for="perihal_surat_permohonan">
                Perihal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input id="perihal_surat_permohonan" v-model="formRekomendasi.perihal_surat_permohonan"
                v-validate="'required'" name="Perihal Surat"></b-form-input>
              <span class="text-danger" v-if="errors.has('Perihal Surat')">
                {{ errors.first('Perihal Surat') }}
              </span>
            </div>
            <div class="col-lg-12 mt-3">
              <label for="tanggal_surat_permohonan">
                Tanggal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input type="date" id="tanggal_surat_permohonan" v-model="formRekomendasi.tanggal_surat_permohonan"
                v-validate="'required'" name="Tanggal Surat"></b-form-input>
              <span class="text-danger" v-if="errors.has('Tanggal Surat')">
                {{ errors.first('Tanggal Surat') }}
              </span>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click="submitRekomendasi" :disabled="isLoading">
            <img src="@/assets/icons/archive.svg" />
            Simpan
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script src="https://cdn.datatables.net/fixedcolumns/4.1.0/js/dataTables.fixedColumns.min.js"></script>
<script>
import Vue from 'vue'
import moment from 'moment'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import Swal from 'sweetalert2'
import axios from 'axios'
import VueLoading from 'vuejs-loading-plugin'
import * as xlsx from 'xlsx'
import InputFile from '../../Components/InputFile.vue'
import dayjs from 'dayjs'
import FileDownload from "../../Components/FileDownload.vue";

// using default options
Vue.use(VueLoading)

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Loading', // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: 'rgb(255,255,255)', // set custom background
  classes: ['myclass'], // array, object or string
})
export default {
  components: { ClassicEditor, vSelect, InputFile, FileDownload},
  data() {
    return {
      fields: [
        { key: 'no' },
        { key: 'nama_pemohon', sortable: true },
        { key: 'nomor_permohonan', sortable: true },
        { key: 'jenis_kegiatan', sortable: true },
        { key: 'status_verdok', label: 'Status Verdok', sortable: true },
        { key: 'status_vertek', label: 'Status Pentek', sortable: true },
        { key: 'tanggal_pada_permohonan', label: 'Tanggal Permohonan' },
        { key: 'file_undangan', label: 'Undangan Pentek' },
        { key: 'file_ba', label: 'File BA' },
        { key: 'file_memo', label: 'File Memo' },
        'Aksi',
      ],

      // currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      dataPerDokumen: [],
      wygEditor: ClassicEditor,
      dataRoles: [],
      dataPermohonan: [],
      optionsPrioritas: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
      selectedFile: null,
      isLoading: false,
      formRekomendasi: {
        jenis_rekomendasi: 'Habis Masa Berlaku',
        file_rekomendasi: null,
        nomor_surat_permohonan: null,
        perihal_surat_permohonan: null,
        tanggal_surat_permohonan: null,
      },

      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: 'nama_pemohon',
        value: '',
      },
      sort: {
        field: 'createdAt',
        direction: 'DESC',
      },
      debounceTerm: null,
      show: false,
    }
  },
  props: {
    user: {
      default: () => {
        return []
      },
    },
    baseapi: String,
  },
  methods: {
    format_date(value, format = 'DD MMMM YYYY') {
      if (value) {
        return dayjs(value).format(format)
      }
    },

    async getdata() {
      $('#berusahaPTSA').DataTable().destroy()
      await this.loaddata()
    },

    loaddata() {
      this.show = true
      this.dataPermohonan = []
      // prettier-ignore
      const api = `api/permohonan/dataTable`+
        `?page=${this.pagination.currentPage}`+
        `&filter=keterangan_status,=,Terbit`+
        `${this.search.value!==''?`;${this.search.field},${this.search.field==='tanggal_pada_permohonan'||this.search.field==='tanggal_terbit_oss'?'=>':'like'},${this.search.value}`:''}`+
        `&sort=${this.sort.field},${this.sort.direction}`
      return axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage =
            (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data

          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], 'selectedFile', null)
          }
          this.initDatatable()
        })
        .catch((error) => {
          console.log(error)
          return error
        })
        .finally(() => {
          this.show = false
        })
    },

    showModalRekomendasi(record) {
      this.selectedData = record
      this.$bvModal.show('modal-rekomendasi')
    },

    async submitRekomendasi() {
      this.$validator.validateAll().then(async (res) => {
        if (res) {
          this.$loading(true)
          this.isLoading = true
          const {
            nama_pemohon,
            nomor_oss,
            tanggal_terbit_oss,
            masa_berlaku,
            nib_pemohon,
            npwp_pemohon,
            nomor_permohonan,
          } = this.selectedData
          const {
            jenis_rekomendasi,
            file_rekomendasi,
            nomor_surat_permohonan,
            perihal_surat_permohonan,
            tanggal_surat_permohonan,
          } = this.formRekomendasi

          const formData = new FormData()

          // prettier-ignore
          if (jenis_rekomendasi === 'Pembatalan') {
            formData.append('file_permohonan_pemuktahiran', file_rekomendasi)
            formData.append('nomor_surat_permohonan', nomor_surat_permohonan)
            formData.append('perihal_surat_permohonan', perihal_surat_permohonan)
            formData.append('tanggal_surat_permohonan', tanggal_surat_permohonan)
            formData.append('jenis_pemuktahiran', 'Pengembalian')
            formData.append('jenis_permohonan', 'Berusaha')
            formData.append('nomor_izin_terbit', nomor_oss)
            formData.append('instansi_pemohon', nama_pemohon)
            formData.append('nib', nib_pemohon)
            formData.append('npwp', npwp_pemohon)
            formData.append('nomor_permohonan', nomor_permohonan)
            formData.append('tanggal_penerbitan_izin', tanggal_terbit_oss)
            formData.append('status_persetujuan', 'Terima')
            formData.append('status', 'Menunggu Jadwal Penilaian')
          } else {
            formData.append('jenis_permohonan', 'Berusaha')
            formData.append('nama_pemohon', nama_pemohon)
            formData.append('nomor_izin_terbit', nomor_oss)
            formData.append('tanggal_penerbitan', tanggal_terbit_oss)
            formData.append('masa_berlaku', masa_berlaku)
            formData.append('nomor_surat_permohonan', nomor_surat_permohonan)
            formData.append('tanggal_surat_permohonan', tanggal_surat_permohonan)
            formData.append('status', 'Menunggu Jadwal Penilaian')
            if (jenis_rekomendasi === 'Habis Masa Berlaku') {
              formData.append('file_rekomendasi_habis_masa_berlaku', file_rekomendasi)
            } else {
              formData.append('file_rekomendasi_pencabutan', file_rekomendasi)
            }
          }

          let api = ''
          switch (jenis_rekomendasi) {
            case 'Habis Masa Berlaku':
              api = 'api/habis_masa_berlaku'
              break
            case 'Pencabutan':
              api = 'api/pencabutan'
              break
            case 'Pembatalan':
              api = 'api/pemuktahiran'
              break
          }

          try {
            await axios.post(this.baseapi + api, formData, this.getApiOption())
            this.$bvModal.hide('modal-rekomendasi')
            Swal.fire('Berhasil', 'Berhasil membuat rekomendasi', 'success')
            this.formRekomendasi = {
              jenis_rekomendasi: 'Habis Masa Berlaku',
              file_rekomendasi: null,
            }
          } catch (error) {
            Swal.fire('Gagal', 'Gagal membuat rekomendasi', 'error')
          } finally {
            this.$loading(false)
            this.isLoading = false
          }
        }
      })
    },

    async sendReminder(record) {
      const { id, nama_pemohon, nomor_oss } = record
      const confirm = await Swal.fire({
        title: 'Kirim Email Pengingat',
        text: `Kirim email pengingat untuk Pemohon ${nama_pemohon} dengan Nomor Penerbitan ${nomor_oss}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, kirim',
        cancelButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return
      try {
        await axios.post(
          `${this.baseapi}api/permohonan/sendReminder`,
          { id },
          this.getApiOption(),
        )
        Swal.fire('Berhasil', 'Email pengingat berhasil dikirim', 'success')
      } catch (error) {
        Swal.fire('Gagal', 'Email pengingat gagal dikirim', 'error')
      }
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => {})
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (
          this.pagination.currentPage >=
          this.pagination.lastPage - 2
        ) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      $.fn.dataTable.moment('DD MMMM YYYY')
      setTimeout(() => {
        var t = $('#berusahaPTSA').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                return type == 'export' ? meta.row + 1 : data
              },
            },
          ],
          buttons: [],
        })
      }, 300)
    },

    exportData() {
      this.$loading(true)
      // prettier-ignore
      const api = `api/permohonan` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `&filter=keterangan_status,=,Terbit`+
        `${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_pada_permohonan' || this.search.field === 'tanggal_terbit_oss' ? '>=' : 'like'},${this.search.value}` : ''}`

      axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          const worksheetData = [
            ['Data Pemohon'],
            [
              'No',
              'Prioritas',
              'Nama Pemohon',
              'Nomor Pemohon',
              'Jenis Kegiatan',
              'Provinsi',
              'Tgl. Permohonan',
              'Tgl. Penerbitan',
              'No. Izin Terbit',
              'PIC Pentek',
            ],
          ]
          const merge = [
            { s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 } },
          ]

          res.data.data.forEach((d, i) => {
            worksheetData.push([
              i + 1,
              d.prioritas ? 'Prioritas' : '',
              d.nama_pemohon,
              d.nomor_permohonan,
              d.jenis_kegiatan,
              d.lokasi,
              d.tanggal_pada_permohonan,
              d.tanggal_terbit_oss,
              d.nomor_oss,
              d.pic_name,
            ])
          })

          const workbook = xlsx.utils.book_new()
          const worksheet = xlsx.utils.aoa_to_sheet(worksheetData)
          worksheet['!merges'] = merge
          xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

          const d = new Date()
          xlsx.writeFile(
            workbook,
            `Data Pemohon ${d.getFullYear()}-${
              d.getMonth() + 1
            }-${d.getDate()}.xlsx`,
          )
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  mounted() {
    this.getdata()
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata()
      },
      deep: true,
    },
  },
}
</script>
